import Default from './Default';
import Visualizar from './Visualizar';

const CategoriasDefault = Default

export default CategoriasDefault;
export const CategoriasVisualizar = Visualizar;
